export class Instructor {
    public id: string;
    public name: string;
}



// WEBPACK FOOTER //
// ./src/lemsar/institution/domains/model/instructor.ts